<template>
<!-- eSIM QR-Code -->
<div class="app-esim-manual-input mt-5 mb-5 white-box">
    <b-row>
        <b-col  md="6" sm="12" class="mb-4">
            <slot name="header">
                <h2>Manuelle Eingabe</h2>
                <p>Geb die Daten zum Einrichten selber ein. Wir stellen dir hier alles zur Verfügung.</p>
                <p>Hier findest du eine Erklärung für iOS und Android Geräte:<br/>
                    <a href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_Manuell_iOS.pdf" target="_blank" rel="noopener">Anleitung für iOS</a>
                    <br/>
                    <a href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_Manuell_Android.pdf" target="_blank" rel="noopener">Anleitung für Android</a>
                </p>
            </slot>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="6" sm="12" class="mb-1">
            <slot name="lblEpin"> SM-DP + Adresse:</slot>
        </b-col>
    </b-row>
    <b-row>
        <b-col  md="6" sm="12" class="mb-2">
            <b-form-input
            type="text"
            :value="smdp"
            required
            readonly
            autocomplete="off"
            >
            </b-form-input>
        </b-col>
        <b-col>
            <b-button @click="copySmDp()" class="btn" type="button" variant="primary">
                <span><slot name="btnSmDpCopyLbl">Kopieren</slot></span>
            </b-button>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="6" sm="12" class="mb-1">
            <slot name="lblEpin"> Aktivierungscode:</slot>
        </b-col>
    </b-row>
    <b-row>
        <b-col  md="6" sm="12" class="mb-2">
            <b-form-input
            type="text"
            :value="activationCode"
            required
            readonly
            autocomplete="off"
            >
            </b-form-input>
        </b-col>
        <b-col>
            <b-button @click="copyActivationCode()" class="btn" type="button" variant="primary">
                <span><slot name="btnActivationCodeCopyLbl">Kopieren</slot></span>
            </b-button>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="6" sm="12" class="mb-1">
            <slot name="lblEpin"> Bestätigungscode (ePIN):</slot>
        </b-col>
    </b-row>
    <b-row>
        <b-col  md="6" sm="12" class="mb-2">
            <b-form-input
            :type="fieldType"
            :value="ePin"
            required
            readonly
            autocomplete="off"
            @input="() => false"
            >
            </b-form-input>
        </b-col>
        <b-col>
            <b-button @click="toggleEPin()" class="btn" type="button" variant="primary">
                <span v-if="!showEPin"><slot name="btnShowEPinLbl">ePIN anzeigen</slot></span>
                <span v-if="showEPin"><slot name="btnHideEPinLbl">ePIN verstecken</slot></span>
            </b-button>
        </b-col>
    </b-row>
</div>
<!-- /eSIM QR-Code -->
</template>

<script>
export default {
  name: 'ESimManualInput',
  props: {
    smdp: {
      type: String,
      default: ''
    },
    activationCode: {
      type: String,
      default: ''
    },
    ePin: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {
      fieldType: 'password',
      showEPin: false
    }
  },
  computed: {},
  methods: {
    copySmDp () {
      navigator.clipboard.writeText(this.smdp)
    },
    copyActivationCode () {
      navigator.clipboard.writeText(this.activationCode)
    },
    toggleEPin () {
      this.showEPin = !this.showEPin

      if (this.showEPin) {
        this.fieldType = 'text'
      } else this.fieldType = 'password'
    }
  },
  mixins: [],
  apollo: {}
}
</script>
